import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtMoney, STATUS_COLORS, ORDER_STATUSES } from "@/lib/pharmacy";

export default function AdminOrders() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const load = () => {
    const params = {};
    if (status) params.status = status;
    if (q) params.q = q;
    api.get("/admin/orders", { params }).then((r) => setRows(r.data));
  };
  useEffect(load, [status, q]);
  return (
    <div>
      <h1 className="font-display text-3xl font-bold mb-4">Orders</h1>
      <div className="flex flex-wrap gap-3 mb-4">
        <input placeholder="Search order # / name / email" value={q} onChange={(e) => setQ(e.target.value)} className="h-10 rounded-lg border border-slate-200 px-3 text-sm min-w-[240px]" data-testid="admin-orders-search"/>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="h-10 rounded-lg border border-slate-200 px-3 text-sm bg-white" data-testid="admin-orders-filter-status">
          <option value="">All statuses</option>
          {ORDER_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr><th className="text-left p-3">Order</th><th className="text-left p-3">Customer</th><th className="text-left p-3">Pills</th><th className="text-left p-3">Total</th><th className="text-left p-3">Status</th><th className="text-left p-3">Date</th><th></th></tr>
          </thead>
          <tbody>
            {rows.map((o) => (
              <tr key={o.id} className="border-t border-slate-100" data-testid={`admin-order-row-${o.order_number}`}>
                <td className="p-3 font-mono font-semibold">{o.order_number}</td>
                <td className="p-3">{o.shipping.full_name}<div className="text-xs text-slate-500">{o.shipping.email}</div></td>
                <td className="p-3 font-mono">{o.total_pills}</td>
                <td className="p-3 font-mono">{fmtMoney(o.grand_total)}</td>
                <td className="p-3"><span className={`text-xs px-2 py-1 rounded-full ${STATUS_COLORS[o.status]}`}>{o.status}</span></td>
                <td className="p-3 text-slate-500 text-xs">{o.created_at.slice(0,16).replace("T"," ")}</td>
                <td className="p-3 text-right"><Link to={`/admin/orders/${o.id}`} className="text-emerald-700 font-semibold">Open →</Link></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="7" className="p-10 text-center text-slate-500">No orders</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
